import { render } from "./CommonDesignDialog.vue?vue&type=template&id=45e54384&scoped=true&ts=true"
import script from "./CommonDesignDialog.vue?vue&type=script&lang=ts"
export * from "./CommonDesignDialog.vue?vue&type=script&lang=ts"

import "./CommonDesignDialog.vue?vue&type=style&index=0&id=45e54384&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45e54384"]])

export default __exports__